/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import Navbar from './Navbar';
import SidebarMenuLeft from './SidebarMenuLeft';

import styles from '../../../assets/css/layoutMain/layoutMain.module.css';

function LayoutMain({ component, leftComponent }) {
    return (
        <>
            <Navbar />
            <div className={styles.container}>
                <div className={styles.gridContainer}>
                    <div className={styles.sidebarLeft}>
                        <SidebarMenuLeft />

                        {leftComponent}
                    </div>
                    <div className={styles.contentMain}>{component}</div>
                </div>
            </div>
        </>
    );
}

LayoutMain.propTypes = {
    component: PropTypes.node.isRequired,
    leftComponent: PropTypes.node.isRequired
};

export default LayoutMain;
